// extracted by mini-css-extract-plugin
module.exports = {"number-input-with-spinners":"number-input-with-spinners-2FWOl_q","invalid":"invalid-25MdRv_","buttons":"buttons-19ZBAat"};